export enum PaetepRoles
{
    BuildingPrincipal = "Building_Principal",
    Registered_User = "Registered Users",
    SupervisorCurriculumInstruction	= "Sup_Curr_Instruction",
    SupervisorPupilServices	= "Sup_Pupil_Services",
    SupervisorSpecialEducation= "Sup_Spec_Education",
    SupervisorVocationalEducation = "Sup_Voc_Education",
    SupervisorNTPEOther = "NTPE_Other_Supervisor",
    DistrictAdmin = "SchoolDistrict_Admin",
    Substitute = "Substitute",
    EmergencyCertified = "Emergency_Cert",
    SupCurrInstruction = "Sup_Curr_Instruction",
    SupPupilServices = "Sup_Pupil_Services",
    SupSpecEducation = "Sup_Spec_Education",
    SupVocEducation = "Sup_Voc_Education",
    NTPEOtherSupervisor = "NTPE_Other_Supervisor",
}
